import { ModelID, SearchParams } from '@/types';
import { Quote } from '@/types';

export type Filter = 'all' | 'active' | 'inactive';
export type Sort = 'created_at' | 'updated_at' | 'quote_id';
export interface QuoteSearchParams extends SearchParams<Filter, Sort>, Partial<Quote> {}

export const featurePath = '/v4/leads/quote';

export const featureKeys = {
  all: [{ scope: 'quotes' }] as const,

  lists: (location: ModelID) => [{ ...featureKeys.all[0], location, entity: 'list' }] as const,

  list: (location: ModelID, search: QuoteSearchParams = {}) =>
    [{ ...featureKeys.lists(location)[0], search }] as const,

  details: () => [{ ...featureKeys.all[0], entity: 'detail' }] as const,

  detail: (id: ModelID) => [{ ...featureKeys.details()[0], id }] as const,
};
